function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "avatar-2-a",
  width: 70,
  height: 70,
  rx: 24
}), React.createElement("linearGradient", {
  id: "avatar-2-c",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#F7B186"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFC299"
})), React.createElement("linearGradient", {
  id: "avatar-2-e",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFC9B3"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFD2C2"
})), React.createElement("path", {
  id: "avatar-2-d",
  d: "M48.563 11.266c1.37 2.78 2.449 7.375 3.237 13.785H0c.789-6.411 1.868-11.006 3.237-13.785.91-1.846 5.587-4.546 14.03-8.1.168-1.625.456-2.553.863-2.786.611-.35 14.812-.35 15.54 0 .485.233.773 1.16.863 2.784 8.445 3.559 13.121 6.26 14.03 8.102z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "avatar-2-b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#avatar-2-a"
})), React.createElement("use", {
  fill: "#A0A6B8",
  opacity: 0.1,
  xlinkHref: "#avatar-2-a"
}), React.createElement("g", {
  mask: "url(#avatar-2-b)"
}, React.createElement("path", {
  d: "M3.5 7h63v63h-63z"
}), React.createElement("path", {
  fill: "url(#avatar-2-c)",
  d: "M32.889 31.022V37.1h-13.7c.017-5.99.017-10.97 0-14.936-3.069-4.032-3.069-6.552-.643-9.157 1.617-1.736 8.182-3.039 19.695-3.907.863 8.423 1.363 13.777 1.498 16.062.082 1.378.963 5.86-2.462 5.86H32.89z",
  transform: "translate(9.1 10.5)"
}), React.createElement("path", {
  fill: "#F08956",
  d: "M42 41.188c-3.052-.373-5.619-1.27-7.7-2.688.971 2.837 3.538 4.704 7.7 5.6v-2.912z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M30.599 26.32c-.688-.59-1.523-.987-2.704-.374-2.8 1.454-.942 7.059 2.191 6.95 1.08-.039.586 2.115-2.303 3.537 0-2.269-3.46-7.888-3.76-13.003-3.483-1.296-2.618-6.48-.227-6.48-.383-4.752 7.23-7.206 10.179-4.48 2.998-3.59 10.566-1.753 11.023 1.362 5.204-2.776 8.625 5.205 3.752 8.302-2.005 1.275-6.695 1.76-13.466 1.76-3.25 0-1.38 7.6-.365 10.054 1.297 3.133 8.541 3.566 10.811 3.241 1.773-.253 2.703-.972 2.811-1.404 1.622 4.322-.432 6.915-3.675 6.915-5.514 0-11.028-1.62-11.893-5.619-.688-3.181-.65-8.316-2.374-10.76z"
}), React.createElement("g", {
  transform: "translate(9.1 44.8)"
}, React.createElement("mask", {
  id: "avatar-2-f",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#avatar-2-d"
})), React.createElement("use", {
  fill: "url(#avatar-2-e)",
  xlinkHref: "#avatar-2-d"
}), React.createElement("path", {
  fill: "#FFA789",
  fillRule: "nonzero",
  d: "M-3.453 7.538h58.059v1.724h-58.06V7.538zm0 4.308h58.059v1.723h-58.06v-1.723zm0 4.308h58.059v1.723h-58.06v-1.723zm0 4.308h58.059v1.723h-58.06v-1.723z",
  mask: "url(#avatar-2-f)"
}))));

var SvgAvatar3 = function SvgAvatar3(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAvatar3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avatar-3.98ab4fcf.svg";
export { ForwardRef as ReactComponent };